import React, { useContext } from 'react';
import { useTheme } from '@mui/material/styles';
import { UiContext } from 'shared/lib/contexts/uiContext';
import cx from 'classnames';
import { defaultSpacingPresets } from 'shared/hooks/useGetSpacing';
import { IconProps } from 'shared/icons/iconProps';

export default function IconEdit({
  extColor,
  isAutoscallable = true,
  sizeKey = '18x18',
  onClick,
  style,
}: IconProps) {
  const theme = useTheme();
  const fill = extColor || theme.palette.text.primary;
  const {
    spacings: {
      icons: { [sizeKey]: size },
    },
  } = useContext(UiContext);

  const w = isAutoscallable ? size.w : defaultSpacingPresets.icons[sizeKey].w;
  const h = isAutoscallable ? size.h : defaultSpacingPresets.icons[sizeKey].h;

  return (
    <svg
      className={cx('icon', { 'icon-disabled': !onClick })}
      onClick={onClick}
      style={style}
      width={w}
      height={h}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 18 18"
      fill={fill}
    >
      <path d="M16.182 4.96 13.04 1.818a1.406 1.406 0 0 0-1.988 0l-8.671 8.67a1.397 1.397 0 0 0-.412.995v3.142a1.406 1.406 0 0 0 1.406 1.406h11.813a.843.843 0 1 0 0-1.687H8.788l7.393-7.395a1.405 1.405 0 0 0 0-1.99Zm-9.784 9.384H3.656v-2.742l5.907-5.907 2.742 2.742-5.907 5.907ZM13.5 7.242 10.758 4.5l1.29-1.29 2.742 2.743-1.29 1.29Z" />
    </svg>
  );
}
